import { openDB } from "idb";
import { globalState } from "./state.svelte";
export let dbPromise = openDB("audio-extender", 1, {
    upgrade(db, oldVersion, newVersion, transaction) {
        switch (oldVersion) {
            case 0:
                db.createObjectStore("library", { keyPath: "name" });
        }
    },
});
export async function checkLibraryEmpty() {
    let db = await dbPromise;
    let keys = await db.getAllKeys("library", null, 1);
    globalState.isLibraryEmpty = keys.length === 0;
}
